import { environment } from '@environments/environment';

export const GET_HANDLES_FILTER_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions,
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
          {
            term: {
              vid: 'style_poignee',
            },
          },
        ],
      },
    },
    _source: ['name'],
  },
});
